import css from 'styled-jsx/css';

const styles = css.global`html {
  scroll-behavior: smooth;
  scroll-padding-top: 58px;
}

.jornada-simulacao #proposal-id {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

.jornada-simulacao {
  padding: 24px 0;
  box-sizing: border-box;
}

.jornada-simulacao .stepper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.jornada-simulacao .stepper .step-title {
  margin: 0 0 8px;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222222;
}

.jornada-simulacao .stepper-bars {
  display: flex;
  flex-direction: rpw;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8.25px;
}

.jornada-simulacao .stepper-bars .step {
  width: 100%;
  height: 4px;
  background-color: #cccccc;
  border-radius: 2px;
}

.jornada-simulacao .stepper-bars .step.active {
  background-color: #cc0000;
}

.jornada-simulacao .step-label {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  color: #a2a2a2;
  margin-top: 8px;
}

#santander-header.fix-z-index,
#santander-sidebar.fix-z-index {
  z-index: 8999 !important;
}

.jornada-simulacao .modal-backdrop {
  z-index: 9000;
  background-color: #606060;
  backdrop-filter: unset;
  mix-blend-mode: multiply;
  background-blend-mode: multiply;
}

.jornada-simulacao .modal-component {
  z-index: 9001;
}

.jornada-simulacao.informacoes-basicas,
.jornada-simulacao.consumo,
.jornada-simulacao.simulacao {
  min-height: 616px;
}

.jornada-simulacao.error,
.jornada-simulacao.fim-apartamento,
.jornada-simulacao.fim-loja-nao-encontrada {
  min-height: 632px;
}

.jornada-simulacao.final {
  min-height: 660px;
}

@media (max-width: 991px) {
  #santander-header.simulacao-energia-solar {
    background: #cc0000;
  }

  #santander-header.simulacao-energia-solar .wrapper-mb.mobile {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  #santander-header.simulacao-energia-solar .wrapper-mb.mobile > button,
  #santander-header.simulacao-energia-solar .wrapper-mb.mobile > .row-header {
    display: none;
  }

  #santander-header.simulacao-energia-solar.with-voucher #logo-santander-header-mobile {
    display: none;
  }

  #santander-header.simulacao-energia-solar .voucher-header-mobile {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    height: 58px;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  #santander-header.simulacao-energia-solar .voucher-header-mobile p {
    font-family: 'SantanderText';
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0%;
    text-align: center;
    color: #fff;
  }

  #santander-header.simulacao-energia-solar .voucher-header-mobile button,
  #santander-header.simulacao-energia-solar .voucher-header-mobile span {
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
}

@media (min-width: 992px) {
  html {
    scroll-padding-top: 140px;
  }

  .jornada-simulacao {
    padding: 40px 0;
    min-height: 1024px;
  }

  #santander-header.fix-z-index + #fixed-spacer {
    height: 80px !important;
  }

  .jornada-simulacao.informacoes-basicas {
    min-height: 1024px;
  }

  .jornada-simulacao.error {
    min-height: 800px;
  }

  .jornada-simulacao.fim-apartamento {
    min-height: 1024px;
  }

  .jornada-simulacao.final {
    min-height: 884px;
  }

  #santander-header.simulacao-energia-solar .voucher-header-mobile {
    display: none !important;
  }
}
`;

export default styles;